module.exports = __webpack_public_path__ + "static/da1000-7702c910075628d2c5b6dedbf27264ed.png";